"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailSchema = void 0;
var constants_1 = require("../../constants");
exports.detailSchema = {
    type: 'object',
    required: [
        'contested',
        'dateLegalActionCompleted',
        'dateLegalActionStarted',
        'dueDateOfLastCompleteInstallmentPaid',
        'eviction',
        'interestAdjustmentDate',
        'interestAtDefaultRate',
        'legalSystemType',
        'mobileHomeOnLeasedLand',
        'mortgageType',
        'taxAccountBalanceAmount',
        'taxAccountBalanceType',
        'typeOfClaim',
        'unpaidPrincipalBalanceAmount',
    ],
    properties: {
        additionalSecuritiesHeldByBorrower: {
            type: 'number',
            enum: Object.values(constants_1.AdditionalSecuritiesHeldByBorrower),
            errorMessage: 'should be a valid AdditionalSecuritiesHeldByBorrower Enum value',
        },
        britishColumbiaYukonSaleClosingDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        calendarDaysDeferredCount: {
            type: 'number',
            minimum: 0,
            maximum: 120,
            errorMessage: 'should be numeric between 0 and 120',
        },
        claimFilingExtensionObtained: {
            type: 'boolean',
            errorMessage: 'should be true or false',
        },
        contested: {
            type: 'boolean',
            errorMessage: 'should be true or false',
        },
        dateApprovedLenderNotifiedToSubmitClaim: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        dateLegalActionCompleted: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        dateLegalActionStarted: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        dateOfferAccepted: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        deficiencySaleClosingDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        deficiencySalePrice: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        dueDateOfLastCompleteInstallmentPaid: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        eviction: {
            type: 'boolean',
            errorMessage: 'should be true or false',
        },
        interestAdjustmentDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        interestAtDefaultRate: {
            type: ['number', 'null'],
            maximum: 999999,
            minimum: -999999,
            decimal: [10, 4],
            errorMessage: 'should be a decimal with up to 10 digits in total and 4 digits of precision',
        },
        legalActionType: {
            type: 'number',
            enum: Object.values(constants_1.LegalActionType),
            errorMessage: 'should be a valid LegalActionType Enum value',
        },
        legalSystemType: {
            type: 'number',
            enum: Object.values(constants_1.LegalSystemType),
            errorMessage: 'should be a valid LegalSystemType Enum value',
        },
        mainClaimDueDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        mobileHomeOnLeasedLand: {
            type: 'boolean',
            errorMessage: 'should be true or false',
        },
        mortgageType: {
            type: 'number',
            enum: Object.values(constants_1.MortgageType),
            errorMessage: 'should be a valid MortgageType Enum value',
        },
        otherLegalActionType: {
            type: 'string',
            minLength: 1,
            maxLength: 60,
            errorMessage: 'should have maximum length of 60 characters',
        },
        propertyOccupancyStatus: {
            type: 'number',
            enum: Object.values(constants_1.PropertyOccupancyStatus),
            errorMessage: 'should be a valid PropertyOccupancyStatus Enum value',
        },
        propertySoldBy: {
            type: 'number',
            enum: Object.values(constants_1.PropertySoldBy),
            errorMessage: 'should be a valid PropertySoldBy Enum value',
        },
        propertyTransferredBy: {
            type: 'number',
            enum: Object.values(constants_1.PropertyTransferredBy),
            errorMessage: 'should be a valid PropertyTransferredBy Enum value',
        },
        propertyVacancyDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        propertyVacatedBy: {
            type: 'number',
            enum: Object.values(constants_1.PropertyVacatedBy),
            errorMessage: 'should be a valid PropertyVacatedBy Enum value',
        },
        realEstateCommissionPaid: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        representativeToObtainKey: {
            type: 'object',
            required: [],
            properties: {
                fullName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 35,
                    errorMessage: 'should have maximum length of 35 characters',
                },
                phoneNumber: {
                    type: 'string',
                    minLength: 10,
                    maxLength: 10,
                    errorMessage: 'should have length of 10 characters',
                },
            },
        },
        taxAccountBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        taxAccountBalanceType: {
            type: 'number',
            enum: Object.values(constants_1.TaxAccountBalanceType),
            errorMessage: 'should be a valid TaxAccountBalanceType Enum value',
        },
        typeOfClaim: {
            type: 'number',
            enum: Object.values(constants_1.TypeOfClaim),
            errorMessage: 'should be a valid TypeOfClaim Enum value',
        },
        unpaidPrincipalBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        warrantyType: {
            type: 'number',
            enum: Object.values(constants_1.WarrantyType),
            errorMessage: 'should be a valid WarrantyType Enum value',
        },
    },
};
exports.default = exports.detailSchema;
